import { render, staticRenderFns } from "./MessageLink.vue?vue&type=template&id=5c052452"
import script from "./MessageLink.vue?vue&type=script&lang=js"
export * from "./MessageLink.vue?vue&type=script&lang=js"
import style0 from "./MessageLink.vue?vue&type=style&index=0&id=5c052452&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c052452')) {
      api.createRecord('5c052452', component.options)
    } else {
      api.reload('5c052452', component.options)
    }
    module.hot.accept("./MessageLink.vue?vue&type=template&id=5c052452", function () {
      api.rerender('5c052452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/Message/MessageLink.vue"
export default component.exports